/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import confluentLogo from '@/assets/confluent/confluent-logo.png'

const handleStyleLeft = { left: -2, top: 44 }

function ConfluentNode({ data, isConnectable }) {
  return (
    <div className="custom-node-plc plc-limits">
      <Handle type="target" position={Position.Left} style={handleStyleLeft} />

      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={confluentLogo} alt="Conlfuent Logo" className="custom-node-partner-logo" />
          </div>
          <div className="text-center">
            <b>Confluent</b>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfluentNode
